import React from 'react';
import {
  getTimezoneDate,
  translate,
} from 'containers/MundialViews/utils/mundialUtils';
import './style.scss';

export const CalendarTitle = ({ jornada, dates, translations }) => {
  let dateInfo = getTimezoneDate(dates.timeFrom);

  return (
    <div className="calendar-title">
      <p className="calendar-title__journal">
        {jornada?.names?.default}{' '}
        {translate('matches_result_separatorPipe_label', translations)}{' '}
        {dateInfo.day[0].toUpperCase() + dateInfo.day.substring(1)},{' '}
        {dateInfo.date}
      </p>
    </div>
  );
};
